import { isDate, isEmpty, isNil, isObject } from 'lodash';

export type CleanDeep<T> = T extends (infer U)[]
  ? CleanDeep<U>[]
  : T extends object
    ? { [K in keyof T]?: CleanDeep<T[K]> }
    : NonNullable<T>;

export const cleanDeep = <T extends object>(obj: T): CleanDeep<T> => {
  const result = {} as CleanDeep<T>;

  for (const [key, value] of Object.entries(obj)) {
    const typedKey = key as keyof CleanDeep<T>;

    if (isObject(value) && !isDate(value) && !Array.isArray(value)) {
      const cleaned = cleanDeep(value);
      if (isEmpty(cleaned)) {
        continue;
      }
      result[typedKey] = cleaned as CleanDeep<T>[keyof CleanDeep<T>];
      continue;
    }

    if (!isNil(value)) {
      result[typedKey] = value as unknown as CleanDeep<T>[keyof CleanDeep<T>];
    }
  }

  return result;
};
